var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatistics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 8.28076C14.25 6.31324 15.845 4.71826 17.8125 4.71826H20.1875C22.155 4.71826 23.75 6.31325 23.75 8.28076V33.2499H23.3542C23.2154 33.2499 23.0821 33.2261 22.9583 33.1824C22.8345 33.2261 22.7013 33.2499 22.5625 33.2499H15.4375C15.2987 33.2499 15.1655 33.2261 15.0417 33.1824C14.9179 33.2261 14.7846 33.2499 14.6458 33.2499H14.25V8.28076Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 15.8333H8.3125C6.34499 15.8333 4.75 17.4282 4.75 19.3958V32.0624C4.75 32.7183 5.28166 33.2499 5.9375 33.2499H11.875V15.8333Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.125 33.2499H32.0625C32.7183 33.2499 33.25 32.7183 33.25 32.0624V14.6458C33.25 12.6782 31.655 11.0833 29.6875 11.0833H26.125V33.2499Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.70e8dfcc1897273d1c8047ac3f231896.svg";
export { ForwardRef as ReactComponent };